/**
 * Converts an array of field strings into an object with the fields as keys and true as values.
 *
 * @param  {Array} array An array of field strings. E.g. `["foo", "bar"]`
 * @return {Object}      An object with the fields as keys and true as values.
 *                       E.g. `{foo: true, bar: true}`
 */
export function arrayToObject(array) {
  return _.reduce(
    array,
    (m, flag) => {
      if (flag) {
        m[flag] = true;
      }
      return m;
    },
    {}
  );
}

/**
 * Converts a string of space-separated fields into an object with the fields as keys and true as
 * values.
 *
 * @param  {String} fields A string with space-separated field values. E.g. `"foo bar"`
 * @return {Object}        An object with the fields as keys and true as values.
 *                         E.g. `{foo: true, bar: true}`
 */
export function fieldsToObject(fields) {
  return arrayToObject(fields.split(/\s+/));
}



// WEBPACK FOOTER //
// ./app/utils/objectify.js